import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import ErrorFilter from '../helper/errorFilter';
import SingleError from '../helper/SingleError';
import { editProfile } from '../controller';
import { toast } from 'react-toastify';
import { requestHandler } from '../helper';
import { EditValidateFields } from './validate/editValidation';

function MyProfile({ user, getAccountDetails }) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [errors, setErrors] = useState({});
    const [submitCount, setSubmitCount] = useState(0);
    const [image, setImage] = useState(null);
    const [imagePreview, setImagePreview] = useState(null); // State for image preview
    const baseUrl = process.env.REACT_APP_BACKEND_URL;

    const requireField = [
        "userName",
        "email",
    ];

    const [formData, setFormData] = useState({
        userName: user.userName || '',
        email: user.email || '',
        image: user.profileImage || null
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === "image") {
            const file = e.target.files[0];
            if (file) {
                setImage(file);
                const previewUrl = URL.createObjectURL(file);
                setImagePreview(previewUrl); // Set image preview
            }
        } else {
            if (submitCount > 0) {
                let validationErrors = EditValidateFields({ ...formData, [name]: value, image });
                validationErrors = ErrorFilter(validationErrors, requireField);
                setErrors(validationErrors);
                if (Object.keys(validationErrors).length === 0) {
                    delete errors[name];
                    delete errors.image;
                }
            }
            setFormData((prevData) => ({
                ...prevData,
                [name]: value
            }));
        }
    };

    const validateForm = () => {
        const validationErrors = EditValidateFields(formData, requireField);
        setErrors(validationErrors);
        return Object.keys(validationErrors).length === 0; // return true if no errors
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSubmitCount((prevCount) => prevCount + 1);

        if (!validateForm()) {
            return; // stop if validation fails
        }
        const updatedValues = { ...formData };
        const form = new FormData();
        form.append('userName', updatedValues.userName);
        form.append('email', updatedValues.email);
        form.append('image', image);
        await requestHandler(
            async () => await editProfile(form),
            null,
            (res) => {
                toast.success(res.message);
                handleClose(); // Optionally close the modal upon success
                getAccountDetails();
            },
            () => { }
        );
    };

    return (
        <>
            <div className='d-flex align-items-center gap-2' onClick={handleShow}>
                <img src="../images/png/my_profile.png" width={34.47} height={34.47} alt="" />
                My Profile
            </div>

            <Modal className='modal-main' show={show} centered size='md' onHide={handleClose}>
                <Modal.Body>
                    <Modal.Title>
                        <div className="row justify-content-center pb-4">
                            <div className="col-11 col-8">
                                <h2>My Profile</h2>
                            </div>
                        </div>
                    </Modal.Title>
                    <div className='modal-form'>
                        <div className='d-flex justify-content-center align-items-center'>
                            <div className='position-relative'>
                                <div className='my-profile-preview'>
                                    <img className='w-100 h-100' src={imagePreview || (baseUrl + '/' + user.profileImage)} alt="" />
                                </div>
                                <label htmlFor="formFile" className="form-label">
                                    <div className='profile-edit-button'>
                                        <img src="../images/png/edit-button.png" alt="" />
                                    </div>
                                    <input
                                        className="form-control d-none"
                                        type="file"
                                        id="formFile"
                                        name="image"
                                        accept="image/*" // Only accept images
                                        onChange={handleChange} // Call handleChange on file selection
                                    />
                                </label>
                            </div>
                        </div>
                        <h6 className='user-profile-title'>{user.userName}</h6>
                        <Form>
                            <Form.Group className="mb-3">
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="text" placeholder="Enter E-mail" value={formData.email} name="email" onChange={handleChange} />
                                <SingleError error={errors?.email} />
                            </Form.Group>
                            <Form.Group className="mb-3">
                                <Form.Label>Name</Form.Label>
                                <Form.Control type="text" placeholder="Enter Name" value={formData.userName} name="userName" onChange={handleChange} />
                                <SingleError error={errors?.userName} />
                            </Form.Group>
                            <div className='d-md-flex align-items-center gap-3 mt-4'>
                                <button className='cancel-btn' onClick={handleClose} type='button'>Cancel</button>
                                <button className='save-btn' type='button' onClick={handleSubmit}>Save</button>
                            </div>
                        </Form>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default MyProfile;
